import { useTranslation } from 'react-i18next'
import { Switch } from '@/shared/ui/switch'

interface TenantDestinationStatusToggleProps {
  checked: boolean
  disabled?: boolean
  onCheckedChange: (checked: boolean) => void
}

export function TenantDestinationStatusToggle({
  checked,
  disabled,
  onCheckedChange,
}: TenantDestinationStatusToggleProps) {
  const { t } = useTranslation()
  return (
    <div className="flex items-center gap-2">
      <Switch checked={checked} disabled={disabled} onCheckedChange={onCheckedChange} />
      <span className="text-xs text-zinc-600">
        {checked
          ? t('common.active', { defaultValue: 'Active' })
          : t('common.inactive', { defaultValue: 'Inactive' })}
      </span>
    </div>
  )
}
